/** Endpoint #30 — media proxy (§9). The client only ever holds an asset id, never a CDN URL. */

import { apiUrl } from './client';

/**
 * #30 `GET /api/media/:assetId` — used as an `<img src>`, so this builds the URL instead of
 * fetching. `refresh` re-attempts an asset whose `cache_status` is `failed` (§9.2).
 */
export function mediaUrl(assetId: number, options: { refresh?: boolean } = {}): string {
  return apiUrl(`/media/${assetId}`, { refresh: options.refresh });
}
